const LINK_KOMPASS_ORIGINS = [
  'https://app.linkkompass.ai',
  'https://kompass.linkarkitektur.com',
  'https://kompass.nodalit.com',
  'http://localhost:8080',
]

const getCurrentOrigin = () => {
  if (typeof window === 'undefined' || !window.location) {
    return ''
  }
  return window.location.origin
}

const isLinkKompassOrigin = (origin = getCurrentOrigin()) => {
  return LINK_KOMPASS_ORIGINS.includes(origin)
}

export {
  LINK_KOMPASS_ORIGINS,
  isLinkKompassOrigin,
}
